module.exports = __webpack_public_path__ + "img/goods-5.efe1b415.png";